import { TFunction } from "i18next";
import * as Yup from "yup";

export const createCategorySchema = (t: TFunction) =>
    Yup.object().shape({
        title: Yup.string().required(t("addElement.validator.required")),
        picto: Yup.string().required(t("addElement.validator.required")),
        type_id: Yup.string().required(t("addElement.validator.required")),
        parent_id: Yup.string().nullable(),
        primary_color: Yup.string().required(
            t("addElement.validator.required"),
        ),
        background_color: Yup.string().nullable(),
        border_style: Yup.string(),
        border_width: Yup.number().min(0, t("category.border_width_min")),
        user_id: Yup.string().required(t("category.user_id_required")),
    });
